module.exports = __webpack_public_path__ + "static/media/Raffrollo_35627_100x160.028b5ead.png";